import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface CurrentStudentState {
  currentStudentId: number | null;
}

const initialState: CurrentStudentState = {
  currentStudentId: null,
};

export const currentStudentSlice = createSlice({
  name: "currentStudent",
  initialState,
  reducers: {
    setCurrentStudentId: (state, action: PayloadAction<number | null>) => {
      state.currentStudentId = action.payload;
    },
  },
});

export const { setCurrentStudentId } = currentStudentSlice.actions;
